// src/service/CompanyService.ts
import axiosClient from "./axiosClient";
import { ICompanyDTO } from "@interfaces/ICompanyDTO";

const CompanyService = {
  getAllCompanies: async (): Promise<ICompanyDTO[]> => {
    try {
      const response = await axiosClient.get("/company_api/companies_list");
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching companies:", error);
      throw error;
    }
  },

  getCompanyById: async (id: number): Promise<ICompanyDTO | null> => {
    try {
      const response = await axiosClient.get(`/company_api/company/${id}`);
      return response.data || null;
    } catch (error) {
      console.error(`Error fetching company ${id}:`, error);
      throw error;
    }
  },

  createCompany: async (data: Partial<ICompanyDTO>): Promise<ICompanyDTO> => {
    const response = await axiosClient.post("/company_api/create", data);
    return response.data;
  },

  updateCompany: async (data: Partial<ICompanyDTO>): Promise<ICompanyDTO> => {
    const response = await axiosClient.post("/company_api/update", data);
    return response.data;
  },

  deleteCompany: async (id: number): Promise<void> => {
    await axiosClient.delete(`/company_api/delete/${id}`);
  },
};

export default CompanyService;
